import { render, staticRenderFns } from "./CustomerFilterViewComponent.vue?vue&type=template&id=bf6543be&"
import script from "./CustomerFilterViewComponent.vue?vue&type=script&lang=js&"
export * from "./CustomerFilterViewComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports